import ApiService from './api.service';
import JwtService from './jwt.service';
import Config from '../services/config.service';

export default class ProfileService {
  static authorizeUser(user) {
    const GL = Config.CLIENT;
    const clients = [GL, '5f511e1cefe9f50011b7b4d2']; //Gamelearn y Gamelearn Playground
    return user.creatorAccountId && clients.includes(user.creatorAccountId);
  }

  static async loadProfilingData() {
    const appData = await Promise.all([
      ApiService.get('/admins/profile', {
        headers: { 'x-service-id': Config.SERVICES_UID },
      }),
    ]);
    const [user] = appData;

    if (this.authorizeUser(user)) {
      return { user };
    } else {
      alert('UNAUTHORIZED');
      JwtService.destroyTokens();
      location.reload();
    }
  }
}
